import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Collapse, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';

import SubHeader from '../Layout/SubHeader';
import ModelDetails from './components/ModelDetails';
import ModelInput from './components/ModelInput';
import Addressable from './components/ModelOutput/AddressableTab';
import InputVariables from './components/ModelOutput/InputVariablesTab';
import AddrRevByPayor from './components/ModelOutput/AddrRevByPayorTab';
import MarginByPayor from './components/ModelOutput/MarginByPayorTab';
import AddrMarginByPayor from './components/ModelOutput/AddrMarginByPayorTab';
import RevenueByPayor from './components/ModelOutput/RevenueByPayorTab';
import RevenueOpportunity from './components/ModelOutput/RevenueOpportunityTab';
import YearProjections from './components/ModelOutput/YearProjectionsTab';
import './viewStyle.scss';

class ModelView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false,
            open: false,
            isTabsExpanded: true,
            activeTab: 'InputVariables',
            disabledState: true,
        };
        this.setTabsPaneOpen = this.setTabsPaneOpen.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    /**
     * Render ui elements
     */
    render() {
        const { isTabsExpanded, activeTab, disabledState } = this.state;
        return (
            <div className="model-view-container">
                <Row>
                    <Col md={12}>
                        <SubHeader />
                    </Col>
                </Row>
                <Row className="bg-white">
                    <Col md={12}>
                        <ModelDetails />
                    </Col>
                </Row>

                <Row className="top-margin bg-white">
                    <Col md={12}>
                        <ModelInput />
                    </Col>
                </Row>

                <Row className="top-margin bg-white">
                    <Col md={12}>
                        <div className="box-head" onClick={this.setTabsPaneOpen}>
                            <p className="m-0">MODEL OUTPUT</p>
                            <div className="icon-box">
                                {isTabsExpanded ? (
                                    <FontAwesomeIcon icon={faAngleUp} />
                                ) : (
                                    <FontAwesomeIcon icon={faAngleDown} />
                                )}
                            </div>
                        </div>
                        <Collapse in={isTabsExpanded}>
                            <Row>
                                <Col md={12} className="tab-container">
                                    <Tabs
                                        id="model-output"
                                        activeKey={activeTab}
                                        defaultActiveKey="Addressable"
                                        className="pt-2 pl-2 bg-white"
                                        onSelect={this.handleTabChange}
                                    >
                                        <Tab
                                            eventKey="Addressable"
                                            className="bg-white"
                                            title="Addressable Opportunity (Revenue)"
                                            disabled={disabledState}
                                        >
                                            <Addressable activeTab={activeTab} onLoadComplete={this.onLoadComplete} />
                                        </Tab>
                                        <Tab
                                            eventKey="InputVariables"
                                            className="bg-white"
                                            title="Addressable Opportunity Variables"
                                            disabled={disabledState}
                                        >
                                            <InputVariables
                                                activeTab={activeTab}
                                                className="tab-iv"
                                                onLoadComplete={this.onLoadComplete}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="RevenueOpportunity"
                                            className="bg-white"
                                            title="Global Opportunity (Revenue)"
                                            disabled={disabledState}
                                        >
                                            <RevenueOpportunity
                                                activeTab={activeTab}
                                                onLoadComplete={this.onLoadComplete}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="RevenueByPayor"
                                            className="bg-white"
                                            title="Global Revenue by Payor Mix"
                                            disabled={disabledState}
                                        >
                                            <RevenueByPayor
                                                activeTab={activeTab}
                                                onLoadComplete={this.onLoadComplete}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="AddrRevByPayor"
                                            className="bg-white"
                                            title="Addr Rev by Payor Mix"
                                            disabled={disabledState}
                                        >
                                            <AddrRevByPayor activeTab={activeTab} onLoadComplete={this.onLoadComplete} />
                                        </Tab>
                                        <Tab
                                            eventKey="MarginByPayor"
                                            className="bg-white"
                                            title="Global Margin by Payor Mix"
                                            disabled={disabledState}
                                        >
                                            <MarginByPayor activeTab={activeTab} onLoadComplete={this.onLoadComplete} />
                                        </Tab>
                                        <Tab
                                            eventKey="AddrMarginByPayor"
                                            className="bg-white"
                                            title="Addr Margin by Payor Mix"
                                            disabled={disabledState}
                                        >
                                            <AddrMarginByPayor activeTab={activeTab} onLoadComplete={this.onLoadComplete} />
                                        </Tab>
                                        <Tab
                                            eventKey="FiveYearProjections"
                                            className="bg-white"
                                            title="5 Year Forecast"
                                            disabled={disabledState}
                                        >
                                            <YearProjections
                                                activeTab={activeTab}
                                                onLoadComplete={this.onLoadComplete}
                                            />
                                        </Tab>
                                    </Tabs>
                                </Col>
                            </Row>
                        </Collapse>
                    </Col>
                </Row>
                <div
                    ref={(el) => {
                        this.messagesEnd = el;
                    }}
                />
            </div>
        );
    }

    /**
     * Handle tab change
     * @param {*} tabName tab name
     */
    handleTabChange(tabName) {
        let isAlreadyVisited = this.props.lookerTabsVisited[tabName];
        this.setState({
            activeTab: tabName,
            disabledState: !isAlreadyVisited,
        });
    }

    /**
     * On load complete
     */
    onLoadComplete = () => {
        this.setState({
            disabledState: false,
        });
    };

    /**
     * Set tab open
     */
    setTabsPaneOpen() {
        this.setState({
            isTabsExpanded: !this.state.isTabsExpanded,
        });
        setTimeout(() => {
            this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    }
}

/**
 * Set redux state to props
 * @param {*} state state
 */
const MapStateToProps = (state) => {
    return {
        lookerParamsUpdated: state.lookerParamsUpdated,
        modelDetails: state.modelChangeAction,
        lookerTabsVisited: state.lookerTabsVisited,
    };
};

ModelView.propTypes = {
    history: PropTypes.object,
    lookerTabsVisited: PropTypes.object,
};

export default connect(MapStateToProps, null)(ModelView);
